// src/components/atoms/ProgressMarker.js

import React from "react";
import { Tooltip, Typography } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const ProgressMarker = ({ interaction, onClick, style }) => {
  return (
    <Tooltip
      title={
        <>
          <Typography variant="subtitle2">{interaction.title}</Typography>
          <Typography variant="body2">{interaction.description}</Typography>
          <Typography variant="body2">
            <a
              href={interaction.callToActionURL}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "inherit", textDecoration: "underline" }}
            >
              {interaction.callToAction}
            </a>
          </Typography>
        </>
      }
      arrow
      placement="top"
    >
      <FiberManualRecordIcon
        fontSize="small"
        onClick={onClick}
        sx={{
          color: "white",
          cursor: "pointer",
          position: "absolute",
          top: -4, // Adjust based on progress bar height
        }}
        style={style}
      />
    </Tooltip>
  );
};

export default ProgressMarker;
